export default __webpack_public_path__ + "images/01ce91e7b0b9650bd91589d5ea23f39f-detroit_mobile.webp";